import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Navbar from '../../../components/navbar/Navbar'
import styled from './TeacherDetails.module.css'
import { SubmitButton } from '../../../components/styled/styledbuttons/buttons'
import { useNavigate } from 'react-router-dom'
import maleAvatar from "../../../assets/maleAvatar.webp"
import { doc, getDoc, updateDoc, arrayUnion } from 'firebase/firestore'
import { auth, db} from '../../../firebase/firebase'
import { useTeacher } from '../../../context/TeacherProvider'
import { useTranslation } from 'react-i18next'
import { youtubeUrlToEmbedSrc } from '../../../utils/youtubeEmbedUrl'
import { isApprovedTeacher } from '../../../utils/teacherStatus'

const TeacherDetails = () => {
  const {userId} = useParams()
  const navigate = useNavigate()
  const [teacher, setTeacher] = useState(null)
  const [loaded, setLoaded] = useState(false)
  const [comment, setComment] = useState("")
  const { setTeacherID } = useTeacher(); 
  const { t } = useTranslation()
  useEffect(() => {
    const fetchTeacherData = async () => {
      try {
        const docRef = doc(db, "teachers", userId
        );  
        const docSnap = await getDoc(docRef);  
        if (docSnap.exists() && isApprovedTeacher(docSnap.data())) {
          setTeacher(docSnap.data());  
        } else {
          setTeacher(null);
        }
      } catch (error) {
        console.error("Error getting document:", error);
        setTeacher(null);
      } finally {
        setLoaded(true);
      }
    };

    fetchTeacherData();
    
  }, [userId]);

  const handleCommentSubmit = async () => {
    if (comment.trim() === "") {
      alert(t('TeacherDetails.Comment cannot be empty'));
      return;
    }

    try {
      const docRef = doc(db, "teachers", userId);
      await updateDoc(docRef, {
        comments: arrayUnion(` ${comment} --- Comment done by student: ${auth.currentUser.displayName} 
  with ID: ${auth.currentUser.uid} 
  `), 
      });
      alert(t('TeacherDetails.Comment submitted successfully'));
      setComment(""); 
    } catch (error) {
      console.error(t('TeacherDetails.Error submitting comment'), error);
    }
  };

  if (loaded && !teacher) {
    return (
      <>
        <Navbar />
        <div className={styled.container}>
          <p>{t("TeacherDetails.No such document!")}</p>
          <SubmitButton onClick={() => navigate(-1)} className={styled.goBackBtn}>
            &#x2190; {t("TeacherDetails.Go Back")}
          </SubmitButton>
        </div>
      </>
    );
  }
  
  return (
    <>

      <Navbar />
      <div className={styled.container}>
        <div className={styled.infoSide}>
          <img className={styled.img} src={teacher?.profileImage || maleAvatar} alt="" />
          <h3>  {t('TeacherDetails.Teacher')} {teacher?.firstName} {teacher?.lastName}</h3>
          {/* <h3>{teacher?.gender}</h3> */}
          <h3>
            {teacher?.birthYear != null &&
            teacher?.birthYear !== "" &&
            !Number.isNaN(Number(teacher.birthYear))
              ? `${new Date().getFullYear() - Number(teacher.birthYear)} ${t('TeacherDetails.Years Old')}`
              : null}
          </h3>
          <div>
          <SubmitButton   onClick={() => {
        setTeacherID(userId); // Set the teacherID globally by using context
        navigate("/calendar");
      }}>
            {t('TeacherDetails.Book a Lesson')}
          </SubmitButton>
          </div>
          <SubmitButton onClick={() => {
            navigate(-1)
          }} className={styled.goBackBtn}> &#x2190; {t('TeacherDetails.Go Back')} </SubmitButton>
        </div>
        <div className={styled.commentSide}>
         <h3>{t('TeacherDetails.CompletedLessons')}: </h3>
         <div className={styled.inputDiv}>
          <label>{t('TeacherDetails.Leave a comment')}</label>
          <textarea onChange={(e) => setComment(e.target.value)} value={comment}  className={styled.comment} type="text" id='comment' maxLength="1500"  > </textarea>
          <SubmitButton onClick={handleCommentSubmit} >{t('TeacherDetails.Submit')}</SubmitButton>
          <div className={styled.introVideo}>
          {
          <div className={styled.video}>
            <h3>{t('TeacherDetails.Intro Video')}</h3>
            <div className={styled.videoFrame}>
              <iframe
                src={youtubeUrlToEmbedSrc(teacher?.introVideo)}
                title={t('TeacherDetails.Intro Video')}
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div> 
          }
          </div>
         </div>
        </div>
      </div>
    </> 
  )
}

export default TeacherDetails